<template>
    <div>
        <highcharts :options="config"></highcharts>
    </div>
</template>

<script>
    import {deepMerge} from "../../helpers/deepMerge";

    export default {
        props: {
            options: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        mounted() {
            this.$emit('init');
        },
        computed: {
            config() {
                return deepMerge({
                    chart: {
                        height: 400
                    },
                    credits: {
                        enabled: false
                    },
                    series: [],
                    xAxis: {
                        categories: []
                    },
                    yAxis: {
                        title: {
                            enabled: true
                        }
                    },
                    legend: {
                        enabled: true
                    },
                    title: undefined
                }, this.options);
            }
        },
    }
</script>
